export default __webpack_public_path__ + "img/ddxflOHo.f439e4c7.svg";